/* src/app/warehousing/pages/stock-movement-labels/stock-movement-labels.component.scss */
.labelSheet {
  display: flex;
  flex-flow: row wrap;
  gap: 2mm;
}
/*# sourceMappingURL=stock-movement-labels.component.css.map */
